module.exports = __webpack_public_path__ + "static/media/flags_credit.356a3180.svg";